module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-mediaviewer"
  }, [_c('div', {
    staticClass: "kiwi-mediaviewer-controls"
  }, [_c('a', {
    staticClass: "u-button u-button-warning kiwi-mediaviewer-controls-close",
    on: {
      "click": _vm.closeViewer
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    key: _vm.url
  }, [_c('a', {
    staticClass: "embedly-card",
    attrs: {
      "href": _vm.url,
      "data-card-key": _vm.embedlyKey,
      "data-card-chrome": "0",
      "data-card-controls": "0",
      "data-card-recommend": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('media_loading', {
    url: _vm.url
  })))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7328b11b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaViewer.vue
// module id = 495
// module chunks = 2